import { z } from 'zod/v4';
import {
  ENTITY_HISTORY_DEFAULT_PAGE_SIZE,
  ENTITY_HISTORY_MAX_PAGE_SIZE,
} from '../../constants.js';

/**
 * Keyset pagination on `id`: `cursor` is the id of the last entry the caller
 * has, the next page is everything older. No page number and no total —
 * counting a history table is the expensive part, and the reader is a
 * "Load more" feed that never needs one.
 */
export const EntityHistoryListQuerySchema = z.object({
  cursor: z.uuid().optional(),
  limit: z.coerce
    .number()
    .int()
    .min(1)
    .max(ENTITY_HISTORY_MAX_PAGE_SIZE)
    .default(ENTITY_HISTORY_DEFAULT_PAGE_SIZE),
});

export type EntityHistoryListQuery = z.infer<
  typeof EntityHistoryListQuerySchema
>;

/** The page envelope every history list route returns as its `data`. */
export const buildEntityHistoryListResponseSchema = <T extends z.ZodTypeAny>(
  entry: T,
) =>
  z.object({
    items: z.array(entry),
    /** Pass back as `cursor` to fetch the next page; null when there is none. */
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
  });

export type EntityHistoryListResponse<T> = {
  items: T[];
  nextCursor: string | null;
  hasMore: boolean;
};
